// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/11/2023
 */

.ProfessionalSelect_selectionContainer__6PF1B {
    position: relative;
    width: 90%;
    margin: 0 auto;
    margin-top: 1.25rem;
}

.ProfessionalSelect_selectionContainer__6PF1B [class^="swiper-slide"] {
    height: auto !important;
}
.ProfessionalSelect_selectionContainer__6PF1B [class^="swiper-button-"]{
    width: 5px;
    color: #5A9BD8;
}

.ProfessionalSelect_selectionContainer__6PF1B [class^="swiper-button-"]::after{
    font-size: 1.2rem;
    font-weight: 600;
}

.ProfessionalSelect_selectionContainer__6PF1B [class\$="-disabled"]{
    display: none;
}

.ProfessionalSelect_selectionContainer__6PF1B [class\$="-prev"]{
    left: -0.5rem !important;
}
.ProfessionalSelect_selectionContainer__6PF1B [class\$="-next"]{
    right: -0.5rem !important;
}

.ProfessionalSelect_professionalsContainer__9iU91 {
    display: flex;
    margin-top: 1.75rem;
}

.ProfessionalSelect_profCard__DuTrl {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.5rem;
    margin: 0 0.5rem;
    border-radius: 0.5rem;
    width: 8rem !important;
    cursor: pointer;
    border: 0.2rem solid #f6fdfd;
    background: linear-gradient(91deg, rgba(50, 115, 190, 0.2) 23.22%, rgba(50, 115, 190, 0) 99.28%);
}

.ProfessionalSelect_profCardSelected__kUX6k {
    border: 0.2rem solid #5A9BD8;
}

.ProfessionalSelect_profImg__Bhitj {
    height: 4.5rem;
    width: 4.5rem;
    border-radius: 100%;
    object-fit: cover;
}

.ProfessionalSelect_profName__yrZuJ {
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    margin: 0.75rem 0;
    text-align: center;
}

.ProfessionalSelect_profDesc__mdVk3 {
    font-size: 0.875rem;
    font-weight: 300;
    text-align: center;
    margin-top: 0.75rem;
    width: 8rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/ProfessionalSelect.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,gGAAgG;AACpG;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 18/11/2023\r\n */\r\n\r\n.selectionContainer {\r\n    position: relative;\r\n    width: 90%;\r\n    margin: 0 auto;\r\n    margin-top: 1.25rem;\r\n}\r\n\r\n.selectionContainer [class^=\"swiper-slide\"] {\r\n    height: auto !important;\r\n}\r\n.selectionContainer [class^=\"swiper-button-\"]{\r\n    width: 5px;\r\n    color: #5A9BD8;\r\n}\r\n\r\n.selectionContainer [class^=\"swiper-button-\"]::after{\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.selectionContainer [class$=\"-disabled\"]{\r\n    display: none;\r\n}\r\n\r\n.selectionContainer [class$=\"-prev\"]{\r\n    left: -0.5rem !important;\r\n}\r\n.selectionContainer [class$=\"-next\"]{\r\n    right: -0.5rem !important;\r\n}\r\n\r\n.professionalsContainer {\r\n    display: flex;\r\n    margin-top: 1.75rem;\r\n}\r\n\r\n.profCard {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 1.5rem;\r\n    margin: 0 0.5rem;\r\n    border-radius: 0.5rem;\r\n    width: 8rem !important;\r\n    cursor: pointer;\r\n    border: 0.2rem solid #f6fdfd;\r\n    background: linear-gradient(91deg, rgba(50, 115, 190, 0.2) 23.22%, rgba(50, 115, 190, 0) 99.28%);\r\n}\r\n\r\n.profCardSelected {\r\n    border: 0.2rem solid #5A9BD8;\r\n}\r\n\r\n.profImg {\r\n    height: 4.5rem;\r\n    width: 4.5rem;\r\n    border-radius: 100%;\r\n    object-fit: cover;\r\n}\r\n\r\n.profName {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    margin: 0.75rem 0;\r\n    text-align: center;\r\n}\r\n\r\n.profDesc {\r\n    font-size: 0.875rem;\r\n    font-weight: 300;\r\n    text-align: center;\r\n    margin-top: 0.75rem;\r\n    width: 8rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectionContainer": `ProfessionalSelect_selectionContainer__6PF1B`,
	"professionalsContainer": `ProfessionalSelect_professionalsContainer__9iU91`,
	"profCard": `ProfessionalSelect_profCard__DuTrl`,
	"profCardSelected": `ProfessionalSelect_profCardSelected__kUX6k`,
	"profImg": `ProfessionalSelect_profImg__Bhitj`,
	"profName": `ProfessionalSelect_profName__yrZuJ`,
	"profDesc": `ProfessionalSelect_profDesc__mdVk3`
};
export default ___CSS_LOADER_EXPORT___;
